module.exports = __webpack_public_path__ + "static/media/warmup.5502314f.jpg";